import React from "react"

const olymptradeLink = [
  "รวว-olymp-trade-–-โบรกเกอรหลอกลวงหรอของจรง",
]

const iqoptionLink = [
  "รวว-iq-option-–-โบรกเกอรหลอกลวงหรอของจรง",
]

class SidebarHome extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      link: undefined,
    }
  }
  componentDidMount() {
    const link = window.location.pathname.replace("/", "");
    this.setState({ link });
  }
  render() {
    return (
      <>
        <div className="col-lg-4 col-md-12">
        <div className="sidebar sticky-top">

<div className="sidebar-rev">

  {(this.state.link && olymptradeLink.some(x => x === decodeURI(this.state.link))) ?
    <>
      <div className="panel panel-default">
        <div className="panel-heading">
        ลงทะเบียน Olymp Trade รับฟรี $ 10,000 ไปยังบัญชี DEMO
        </div>
        <div className="panel-body">
          {<iframe src="https://olymptrade.com/lands/affiliate-new-form/index.html?lang=th&dark=false&square=false&horizontal=false&subid1=fxsinergi-form&subid2=&affiliate_id=1060014&no_redirect=1&freereg=false&auth=false" width="100%" height="320" frameborder="0"></iframe>}
        </div>
      </div>
    </>
    : null
  }
</div>
<div className="sidebar-rev">

  {(this.state.link && iqoptionLink.some(x => x === decodeURI(this.state.link))) ?
    <>
      <div className="panel panel-default">
        <div className="panel-heading">
        ลงทะเบียน IQ Option รับฟรี $ 10,000 ไปยังบัญชี DEMO
        </div>
        <div className="panel-body">
          {<iframe src="https://iqbroker.com/lp/regframe-01-dark/th/?aff=168082&afftrack=fxsinergi-form" width="100%" height="730" frameborder="0"></iframe>}
        </div>
      </div>
    </>
    : null
  }
</div>
{/* <div style={{ textAlign: 'center' }}>
              <a href="https://quotex.io/sign-up/fast/?lid=70867">
                <img src="https://static.quotex.io/files/10_en/336_280.jpg" />
              </a>
            </div> */}
            <div className="sidebar-rev" style={{ marginTop: 10 }}>
              <div className="panel panel-default">
                <div className="panel-heading">
                โบรกเกอร์ Binary Option ที่แนะนำ
                </div>
                <div className="panel-body">
                  <div className="row align-items-center text-md-left text-center">
                    <div className="col-md-4">
                      <a href="https://link.fxsinergi.com/iqoption-all-traffic" rel="nofollow" title="IQ Option">
                        <img alt="iq option thailand" src="https://imgdmf5.s3-ap-southeast-1.amazonaws.com/iqoption86x60.png" />
                      </a>
                    </div>
                    <div className="col-md-8">
                      <div className="stt">
                      บัญชีทดลองใช้ฟรี
                      </div>
                      <div className="stt-su">
                      เงินปันผล : <b>สูงสุด 100 % !*</b>
                      </div>
                      <div className="btn-p2">
                        <a href="/รวว-iq-option-–-โบรกเกอรหลอกลวงหรอของจรง" className="btn-1">รีวิว</a>
                        <a href="https://link.fxsinergi.com/iqoption-all-traffic" rel="nofollow" className="btn-2">เทรดเลยตอนนี้!</a>
                      </div>
                      <div className="stt-su">
                      คำเตือนความเสี่ยง: เงินทุนของคุณอาจมีความเสี่ยง
                      </div>
                    </div>
                  </div>  

                  <div className="row align-items-center text-md-left text-center">
                    <div className="col-md-4">
                      <a href="https://link.fxsinergi.com/olymptrade-all-traffic" rel="nofollow" title="olymptrade thailand">
                        <img alt="olymptrade thailand" src="https://imgdmf5.s3-ap-southeast-1.amazonaws.com/olymptrade-logo.png" />
                      </a>
                    </div>
                    <div className="col-md-8">
                      <div className="stt">
                      บัญชีทดลองใช้ฟรี
                      </div>
                      <div className="stt-su">
                      เงินปันผล : <b>82 % สำหรับบัญชีมาตรฐาน, 90 % สำหรับบัญชี VIP*</b>
                      </div>
                      <div className="btn-p2">
                        <a href="/รวว-olymp-trade-–-โบรกเกอรหลอกลวงหรอของจรง" className="btn-1">รีวิว</a>
                        <a href="https://link.fxsinergi.com/olymptrade-all-traffic" rel="nofollow" className="btn-2">เทรดเลยตอนนี้!</a>
                      </div>
                    </div>
                  </div>  

                  <div className="row align-items-center text-md-left text-center">
                    <div className="col-md-4">
                      <a href="https://link.fxsinergi.com/expertoption" rel="nofollow" title="expertoption">
                        <img alt="expert option thailand" src="https://imgdmf5.s3-ap-southeast-1.amazonaws.com/expertoption86x46.png" />
                      </a>
                    </div>
                    <div className="col-md-8">
                      <div className="stt">
                      ฟีเจอร์ Social trading
                      </div>
                      <div className="stt-su">
                      เงินปันผล : <b>สูงถึง 95 %*</b>
                      </div>
                      <div className="btn-p2">
                        <a href="/expert-option-รวว-–-นเปนสแกมหรอเปนโบรกเกอรทถกกฎหมาย" className="btn-1">รีวิว</a>
                        <a href="https://link.fxsinergi.com/expertoption" rel="nofollow" className="btn-2">เทรดเลยตอนนี้!</a>
                      </div>
                    </div>
                  </div>  
                  
                </div>
              </div>

            </div>
            <div style={{ textAlign: 'center' }}>
              <a href="https://quotex.io/sign-up/fast/?lid=70867">
              <img src="https://static.quotex.io/files/10_en/300_250.jpg"></img>
              </a>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default SidebarHome